/**
 * Replace the in-progress `#query` span with `#tag` + newline.
 * @param {string} text
 * @param {number} suggestStart index of '#'
 * @param {number} cursor selection end (usually caret)
 * @param {string} tag
 * @returns {{ text: string, caret: number }}
 */
function completeTagSuggestion(text, suggestStart, cursor, tag) {
  const raw = text == null ? "" : String(text);
  const start = Math.max(0, Number(suggestStart) || 0);
  const end = Math.max(start, Number(cursor) || 0);
  const name = String(tag || "");
  const insert = `#${name}\n`;
  return {
    text: `${raw.slice(0, start)}${insert}${raw.slice(end)}`,
    caret: start + insert.length,
  };
}

module.exports = { completeTagSuggestion };
